// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"21911106","87":"c67080c9","210":"b70fd8eb","322":"28cbe2a3","369":"75530990","382":"282d2ba9","454":"7f1eafd4","469":"ca102693","602":"e81a44f1","766":"a028e673","829":"d7cf86d1","854":"92266326","919":"0d43442a","924":"6e744505","940":"2732e090"}[chunkId] + ".chunk.js";
};